/**
 * Configuration centralisée de l'API
 * Toutes les URLs et credentials sont chargés depuis les variables d'environnement
 */

// Exportation directe de BASE_URL pour faciliter l'import partout
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5002';

const config = {
  // URL de base de l'API principale
  apiBaseUrl: BASE_URL,
  
  // Configuration SMS (Orange SmartMessage)
  sms: {
    apiUrl: process.env.REACT_APP_SMS_API_URL || 'https://smartmessage.orange.ma/api/v1',
    email: process.env.REACT_APP_SMS_EMAIL || '',
    password: process.env.REACT_APP_SMS_PASSWORD || '',
    sender: process.env.REACT_APP_SMS_SENDER || 'OMNIDOC',
    category: process.env.REACT_APP_SMS_CATEGORY || 'OTP',
  },
  
  // Configuration Navixy (GPS Tracking)
  navixy: {
    apiUrl: process.env.REACT_APP_NAVIXY_API_URL || 'https://api.navixy.com/v2',
    hash: process.env.REACT_APP_NAVIXY_HASH || '',
  },
  
  // Google Maps API Key
  googleMaps: {
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  },

  // Softphone / PBX (WebRTC + SIP)
  pbx: {
    host: process.env.REACT_APP_PBX_HOST || '172.21.5.212',
    wsPort: parseInt(process.env.REACT_APP_PBX_WS_PORT || '8089', 10),
    useWss: process.env.REACT_APP_PBX_USE_WSS !== 'false',
    wsUrl: process.env.REACT_APP_PBX_WS_URL,
    /** Mot de passe SIP commun (ne pas exposer dans l’UI) */
    sipPassword: process.env.REACT_APP_PBX_SIP_PASSWORD || '',
  },
};

// Validation des variables critiques en développement
if (process.env.NODE_ENV === 'development') {
  const requiredVars = [
    'REACT_APP_API_BASE_URL',
  ];
  
  const missingVars = requiredVars.filter(
    (varName) => !process.env[varName]
  );
  
  if (missingVars.length > 0) {
    console.warn(
      '⚠️ Variables d\'environnement manquantes:',
      missingVars.join(', ')
    );
    console.warn('Assurez-vous d\'avoir un fichier .env configuré.');
  }
}

export default config;
